const EMPTY_ROLES = [];
const RETAILER_PRIMARY_ROLE = 'RETAILER_PRIMARY';
const PRIMARY_USER_ROLES = [RETAILER_PRIMARY_ROLE];
const SECONDARY_USER_ROLES = ['RETAILER_SECONDARY'];
const RETAILER_PROSPECTIVE_ROLES = ['RETAILER_PROSPECTIVE'];
const ADMIN_ROLES = ['ADMIN'];
const ADMIN_TEMPORARY_ROLES = ['ADMINTemporary'];
const RETAILER_GROUP_ROLES = ['RETAILER_GROUP'];
const RETAILER_GROUP_TEMPORARY_ROLES = ['RETAILER_GROUPTemporary'];
const USER_ROLES = PRIMARY_USER_ROLES.concat(SECONDARY_USER_ROLES, RETAILER_PROSPECTIVE_ROLES, RETAILER_GROUP_ROLES);
const TEMPORARY_ROLES = ['RETAILER_PRIMARYTemporary', 'RETAILER_GROUPTemporary', 'RETAILER_SECONDARYTemporary', 'ADMINTemporary'];
const LOGGED_USER_ROLES = ADMIN_ROLES.concat(USER_ROLES);
const ANONYOUS_ROLE = TEMPORARY_ROLES.concat(['anonymous', 'mock']);
const ALL_ROLES = ANONYOUS_ROLE.concat(LOGGED_USER_ROLES);
const ADMIN_WITH_PRIMARY_ROLES = ADMIN_ROLES.concat(PRIMARY_USER_ROLES);
export const CHAIN_SUFFIX = 'CHAIN_';
export const RETAILER_TYPE = {
  CHAIN_HEAD: 'CHAIN_HEAD',
  CHAIN_SUBORDINATE: 'CHAIN_SUBORDINATE',
  SUPER_CHAIN: 'SUPER_CHAIN',
  INDEPENDENT: 'INDEPENDENT',
  PROSPECTIVE: 'PROSPECTIVE',
};
export const REGISTRATION_TYPE = {
  RETAILER_ID: 'RetailerId',
  NO_RETAILER_ID: 'NoRetailerId',
};

export default {
  RETAILER_PRIMARY_ROLE,
  EMPTY_ROLES,
  PRIMARY_USER_ROLES,
  SECONDARY_USER_ROLES,
  RETAILER_PROSPECTIVE_ROLES,
  ADMIN_ROLES,
  ADMIN_TEMPORARY_ROLES,
  USER_ROLES,
  TEMPORARY_ROLES,
  LOGGED_USER_ROLES,
  ANONYOUS_ROLE,
  ALL_ROLES,
  ADMIN_WITH_PRIMARY_ROLES,
  RETAILER_GROUP_ROLES,
  RETAILER_GROUP_TEMPORARY_ROLES,
  RETAILER_TYPE,
  CHAIN_SUFFIX,
};



// WEBPACK FOOTER //
// ./src/modules/app/validators/roles.js